import debugHost from '../utils/debugHost';

const HOTS = 'https://order.qunar.com';
// const HOTS = 'http://dev.qunar.com';
// const HOTS = 'http://yapi.corp.qunar.com/mock/6603/order-three';
// const HOTS = 'http://l-ordercenter6.order.beta.cn0.qunar.com:9002';
// const HOTS = 'http://l-userorder1.user.cn1.qunar.com:8080';
const URLS = {
    // orderlist: `${HOTS}/api/wireless/order/query.do`,
    // deleteOrder: `${HOTS}/api/wireless/recycled/delete.do`,
    // cancelShare: `${HOTS}/api/wireless/share/cancle.do`,
    // hasUnbindOrder: `${HOTS}/api/wireless/order/query.do`,
    // hasShareOrder: `${HOTS}/api/wireless/share/query.do`,
    // bindShare: `${HOTS}/api/wireless/share/accept/all.do`,
    // autoBind: `${HOTS}/api/wireless/binding/multi/autoBind.do`,
    autoSearch: 'https://user.qunar.com/ajax/prenumQuery.jsp',
    verifyMobileCode: `${HOTS}/api/wireless/verifyMobileCode.do`,
    sendMobileCode: `${HOTS}/api/wireless/sendMobileCode.do`
    // guideWeChatStatus: 'http://wxapp.qunar.com/api/wechat/getWechatBindState.do'
};

export default debugHost(URLS, HOTS, 'URLS');
